export const CATEGORIES_ACTIONS = {
  INITIALIZE_CATEGORIES: "INITIALIZE_CATEGORIES",
  SHOW_LOADER: "SHOW_LOADER",
};
